import { Component, OnInit, isDevMode, HostListener, ViewChild, NgZone, Renderer, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { AppStateService } from './shared/services/app-state.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { OneSignalService } from "@app/onesignal.service";
import { AccessToken } from '@app/util/accessToken';
import { Meta, Title } from '@angular/platform-browser';
import { AccessToken as MyAccessToken } from "@app/util/accessToken";
import swal from "sweetalert2";
import { Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { GlobalDataSharedService } from './feature/main/roles-shared/services/global-data-shared-service.service';
import { BreadcrumService } from './shared/services/breadcrum.service';
import { VersionCheckService } from './shared/services/version-check.service';
declare var $: any;
declare var window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  leftSideBar: boolean = false; 
  fixLeftMenu: boolean = false; 
  report = 'Reports';
  research = 'Research';
  dashboard = 'Dashboard';
  packageSubscription = 'Package Subscription';
  blog = 'Blog';
  event = 'Event';
  ecosystmTV = 'Ecosystm TV';
  aboutUS = 'About US';
  contactUS = 'Contact US';
  help = 'Help';
  blogURL: string;
  ECOSYSTM_TV_URL: string;
  EVENTS_URL: string;
  wpAutoLoginUrl: string = '';
  mediaURL: string;
  title = 'app';
  isLoggedIn: boolean = false;
  showBanner: boolean = false;
  userDetailsObject;
  userrole:string;
  roleStatus : boolean;
  public version: string = environment.VERSION;
  public envName: string = environment.ENV_NAME;
  public showBuildNo: boolean = environment.SHOW_BUILD_NO;
  @ViewChild('cookieLaw')
  private cookieLawEl: any;
  @HostListener('window:beforeunload', ['$event'])
     public beforeunloadHandler($event) {
      localStorage.removeItem('tempSession');
    }

  constructor(
    private accessTokenService: AccessToken,
    private appState: AppStateService,
    private meta: Meta,
    private titleService: Title,
    private router: Router,
    private ngZone: NgZone,
    private renderer: Renderer,
    private loaderService: LoaderService,
    private oneSignalService: OneSignalService,
    private activatedRoute: ActivatedRoute,
    private myAccessToken: MyAccessToken,
    private globalDataSharedService: GlobalDataSharedService,
    private breadcrumService: BreadcrumService,
    private authenticationService: AuthenticationService,
    private versionCheckService: VersionCheckService,) {
      router.events.subscribe((event: RouterEvent) => {
        this.navigationInterceptor(event);
      });
    this.initalizeMetaTag();

    this.router.events .filter(event => event instanceof NavigationEnd).map(() => this.activatedRoute)
    .map(route => { while (route.firstChild) route = route.firstChild;
       return route; }) 
       .filter(route => route.outlet === 'primary')
      .mergeMap(route => route.data).subscribe((event) => {
        this.titleService.setTitle(event['title'] || 'Ecosystm');
      });
        
      
  }

  // Shows and hides the loading spinner during RouterEvent changes
  private navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      // Run this function outside of Angular's zone to bypass change detection
      this.ngZone.runOutsideAngular(() => {
        this.loaderService.display(true);
      });
    }
    if (event instanceof NavigationEnd) {
      this.loaderService.display(false);
    }
    // Set loading state to false in both of the below events to
    // hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loaderService.display(false);
    }
    if (event instanceof NavigationError) {
      this.loaderService.display(false);
    }
  }



  ngOnInit() {
    this.versionCheckService.initVersionCheck(this.version);
    this.checkDeviceType();
    this.oneSignalService.initOneSignal();
    this.blogURL = environment.BLOG_URL;
    this.ECOSYSTM_TV_URL = environment.ECOSYSTM_TV_URL;
    this.EVENTS_URL = environment.EVENTS_URL;
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.mediaURL = environment.MEDIA;

     const currentSession = localStorage.getItem('tempSession');
     if(currentSession){
       localStorage.setItem('userDetails',currentSession);
      // localStorage.removeItem('tempSession');
     }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    // TODO this has to be changed , its a work-around checks for top navigation bar
    if (window.localStorage.getItem('rememberMeStatus') && window.localStorage.getItem('userDetails')) {
      window.sessionStorage.setItem('userDetails', JSON.stringify(JSON.parse(window.localStorage.getItem('userDetails'))));
    }
    if (window.localStorage.getItem('logoutStatus') === 'false' && window.localStorage.getItem('rememberMeStatus')) {
      this.appState.setState(true);
    }
    if (window.localStorage.getItem('logoutStatus') === 'false' && !window.localStorage.getItem('userDetails')) {
      if (window.localStorage.getItem('userToken')) {
        this.appState.setState(true);
      } else {
        this.appState.setState(false);
      }
    }
    const loggedInUserId = this.accessTokenService.getLoggedUserId();
    const accessToken = this.accessTokenService.getToken();
    if (loggedInUserId && accessToken) {
      this.getUserDetails(loggedInUserId, accessToken);

    }
    this.checkIsLogIn();
  }
  initalizeMetaTag() {
    this.titleService.setTitle('Ecosystm');
  }

  leftSideMenuBar(flag) {
    this.leftSideBar = flag;
   // console.log('this.leftSideBar', this.leftSideBar);
    
  }
  checkIsLogIn() {
    this.appState.loggedIn.subscribe(
      (response: boolean) => {
        // Quick fix to resolve navbar issue
        const session = window.sessionStorage.getItem('userDetails');
        if (session && response) {
          this.isLoggedIn = response;
          const userDetailObject = JSON.parse(session);
          this.userrole = userDetailObject['roles'][0].code;
        } else {
          this.isLoggedIn = false;
        }
      },
      error => { }
    );
  }
  public dismiss(): void {
    if (!this.cookieLawEl.cookieLawSeen) {
      this.cookieLawEl.dismiss();
    }
  }

  getUserDetails(id: string, token: string) {
    this.authenticationService
      .getuserDetails(id, token)
      .subscribe(
        (response: any) => {
          response.userId = this.accessTokenService.getLoggedUserId();
          response.accessToken = this.accessTokenService.getToken();
          const userData =
          {
            salutationId: response.salutationId,
            firstName: response.firstName,
            middleName: response.middleName,
            lastName: response.lastName,
            nickName: response.nickName,
            email: response.email,
            jobTitleId: response.jobTitleId,
            lineOfBusinessId: response.lineOfBusinessId,
            geographicResponsibilityId: response.geographicResponsibilityId,
            organizationId: response.organizationId,
            biography: response.biography,
            isActive: response.isActive,
            profileUrl: response.profileUrl,
            token: this.accessTokenService.getToken()
          }
          this.authenticationService.setAuth(userData);
          
          this.authenticationService.setEBSAuth(response);
          
           let  _hsq = window._hsq = window._hsq || [];
          _hsq.push(["identify",{
            email: ( response!= null) ? response.email: '',
            firstName: ( response!= null) ? response.firstName: '',
            lastName: ( response!= null) ? response.lastName: '',
            role: (response != null && response.roles.length > 0 ) ? response.roles[0].code : '',
          //  contactNumber: (response != null && response.contactNumbers.length > 0 ) ? response.roles[0].contactNumber : ''
          }]);
          _hsq.push(['trackPageView']);
          _hsq.push(['refreshPageHandlers']);
        }, 

        error => {
          this.authenticationService.purgeAuth();
        }
      );
  }

  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem('userDetails'))
    if (userData) {
      token = userData.accessToken;
    }
    else {
      userData = JSON.parse(window.sessionStorage.getItem('userDetails'));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }

  navtoBlogs() {
    let token = this.myAccessToken.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}`;
      window.open(blogUrl, '_self');
    }
    else {
      window.open(this.blogURL, '_self');
    }
  }
  navtoEvents() {
    let token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=events`;
      window.open(eventUrl, '_self');
    }
    else {
      window.open(this.EVENTS_URL, '_self')
    }
  }
  navtoEcosystmTv() {
    let token = this.getToken();
    if (token) {
      const eventUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=ecosystm-tv`;
      window.open(eventUrl, '_self');
    }
    else {
      window.open(this.ECOSYSTM_TV_URL, '_self');
    }
  }
  navRouteToMedia() {
    const token = this.getToken();
    if (token) {
      const mediaURL = `${this.wpAutoLoginUrl}?accesstoken=${token}&redirect_url=media`;
      window.open(mediaURL, '_self');
    } else {
      window.open(this.mediaURL, '_self');
    }
  }
  navtoSupport() {
    this.router.navigate(["support"]);
  }
  removeSession() {
    sessionStorage.removeItem('BC4Url');
    sessionStorage.removeItem('BC4Label');
    sessionStorage.removeItem('BC3Url');
    sessionStorage.removeItem('BC3Label');
    sessionStorage.removeItem('BC2Url');
    sessionStorage.removeItem('BC2Label');
  }
  navtoReportsList() {
    this.removeSession();
    this.router.navigate(["reports"]);
  }
  techVendorNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-vendor"]);
  }
  navtoPackageSubsList() {
    this.removeSession();
    this.router.navigate(["package-subscription"]);
  }
  navtoAllResearchList() {
    this.removeSession();
    this.router.navigate(["research/all-research"]);
  }
  techBuyerNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-buyer"]);
  }
  checkDeviceType() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.showBanner = false;
    }
  }
  routeContactUs() {
    this.router.navigate(["contact-us"]);
  }
  openMobileApp() {
    window.location.href = 'https://ecosystm.page.link/0';
  }
  stickyMenubar() {
    this.fixLeftMenu = !this.fixLeftMenu;
   // console.log('before raise fun call:', this.fixLeftMenu);
    this.globalDataSharedService.raiseEvent(this.fixLeftMenu);
  //  console.log('after raise fun call:', this.fixLeftMenu);
  }
  navtoAnalystList() {
    this.removeSession();
    this.breadcrumService.setUrl('BC2Label', 'Analyst List');
    this.breadcrumService.setUrl('BC2Url', 'analyst-list');
    if (this.userrole == "tech_buyer") {
            this.router.navigate(["tech-buyer/analyst-list"]);
          }else if (this.userrole == "tech_vendor") {
            this.router.navigate(["tech-vendor/analyst-list"]);
          }else if (this.userrole == "tech_analyst"){
            this.router.navigate(["analyst-list"]);
          }else{
            this.router.navigate(["ecosystm-staff/analyst-list"]);
          }
  }
  techAnalystNavtoHome() {
    this.removeSession();
    this.router.navigate(["tech-analyst"]);
  }
  staffNavtoHome() {
    this.removeSession();
    this.router.navigate(["ecosystm-staff"]);
  }

  // Navigate to Analyst Filters page
  techVendorNavtoFilterAnalyst(){
    this.removeSession();
    this.router.navigate(["tech-vendor/filter-analyst"]);
  }
  techBuyerNavtoFilterAnalyst(){
    this.removeSession();
    this.router.navigate(["tech-buyer/filter-analyst"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts